import { types, PackActionsType, PackType } from '../types/pack'

export const initialState: PackType = {
  id: '',
  isLoading: false,
  group: '',
  title: '',
  description: '',
  byline: '',
  language: '',
  contacts: [],
  slugline: '',
  tags: [],
  topicCodes: [],
  created: '',
  createdBy: {
    name: '',
    id: '',
  },
  modifiedBy: {
    name: '',
    id: '',
  },
  previewImages: null,
  publishing: {
    publishing: false,
    published: false,
  },
  editions: [],
}

export const pack = (
  state = initialState,
  action: PackActionsType
): PackType => {
  switch (action.type) {
    case types.CREATE_PACK__STARTED:
    case types.UPDATE_PACK__STARTED:
    case types.PUBLISH_PACK__STARTED:
    case types.GET_PACK_BY_ID__STARTED:
    case types.DELETE_FILE__STARTED:
    case types.DELETE_PACK__STARTED:
      return { ...state, isLoading: true }
    case types.CREATE_PACK__SUCCESS:
    case types.UPDATE_PACK__SUCCESS:
    case types.PUBLISH_PACK__SUCCESS:
    case types.GET_PACK_BY_ID__SUCCESS:
      return { isLoading: false, ...action.packData }
    case types.CREATE_PACK__FAILURE:
    case types.UPDATE_PACK__FAILURE:
    case types.PUBLISH_PACK__FAILURE:
    case types.GET_PACK_BY_ID__FAILURE:
    case types.DELETE_FILE__SUCCESS:
    case types.DELETE_FILE__FAILURE:
    case types.DELETE_PACK__FAILURE:
    case types.CHECK_PACK_BEING_PUBLISHED:
    case types.GET_PACK_BY_ID__NO_UPDATES:
      return { ...state, isLoading: false }
    case types.CLEANUP_PACK:
    case types.DELETE_PACK__SUCCESS:
      return { ...initialState }
    default:
      return state
  }
}
